import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import "./Players.css";
import { Button } from "react-bootstrap";
const Players = (props) => {
  const {
    country,
    name,
    img,
    age,
    BattingStyle,
    BowlingStyle,
    Grade,
    gender,
    salary,
  } = props.playerId;
  return (
    <div className="player ">
      <div className="playerImage">
        <img src={img} alt="" />
      </div>
      <div className="playerInfo">
        <h3>Name: {name}</h3>
        <div className="row">
          <div className="col-md-6">
            <p>Age: {age}</p>
          </div>
          <div className="col-md-6">
            <p>Gender: {gender}</p>
          </div>
        </div>
        <p>Batting Style: {BattingStyle}</p>
        <p>Bowling Style: {BowlingStyle}</p>
        <p>Grade: {Grade}</p>
        <p>Salary: ${salary}</p>
        <p>Country: {country}</p>
        <Button
          className="button"
          onClick={() => props.handleAddPlayer(props.playerId)}
        >
          Select This Player <FontAwesomeIcon icon={faUserPlus} />
        </Button>
      </div>
    </div>
  );
};

export default Players;
